
import axios from 'axios'
import { url } from './url'
import queryStringUtil from "query-string";

function queryString(query) {
    var queryParams = {
        page: query.page,
        pageSize: query.pageSize,
        macAddress: query.macAddress,
        customer: query.customer,
    };
    return queryStringUtil.stringify(queryParams, {
        arrayFormat: "bracket"
    });
}

function getProductions(query) {
    var urlString = `${url}/productions?${queryString(query)}`;
    return axios
        .get(urlString)
        .then(res => {
            return {
                total: res.data.total,
                productions: res.data.productions.map(production => {
                    return {
                        _id: production._id,
                        hardwares: production,
                        totalHardwares: production.macAddress.length,
                        createdAt: production.createdAt,
                        updateAt: production.updateAt,
                        name: production.name,
                        statu: production.statu
                    };
                })
            }
        });
}

function generateMacAddress(production) {
    return axios.post(`${url}/generateMacAddress`, production)
        .then(resp => {
            return resp.data
        })
}

function createProduction(production) {
    return axios.post(`${url}/production`, production)
        .then(resp => {
            return resp.data
        })
}
function sendMailproductionpings(productionping) {
    return axios.post(`${url}/productionping/send_mail`, productionping)
        .then(resp => {
            return resp.data
        })
}
function updateProduction(production) {
    return axios.put(`${url}/production/${production._id}`, production)
        .then(resp => {
            return resp.data
        })
}

function splitProduction(production) {
    return axios.put(`${url}/production/${production._id}/split`, production)
        .then(resp => {
            return resp.data
        })
}

function generateCerts(certsInfo) {
    return axios.put(`${url}/production/${certsInfo._id}/certs`, certsInfo)
        .then(resp => {
            return resp.data
        })
}

export default {
    getProductions,
    createProduction,
    generateMacAddress,
    updateProduction,
    sendMailproductionpings,
    generateCerts,
    splitProduction
};